export default {
  lookups: (state) => state.lookups,
  groups: (state) => state.groups,
  timeZones: (state) => state.timeZones,
  countries: (state) => state.countries,
  stateProvinces: (state) => state.stateProvinces,
  languages: (state) => state.languages,
  brand: (state) => state.brand,
  newInsurance: (state) => state.newInsurance,
  search: (state) => state.search,
  selectedInsurance: (state) => state.selectedInsurance,
  insuranceLookup: (state) => state.insuranceLookup,
  sourceInsurance: (state) => state.sourceInsurance,
  insurance: (state) => state.insurance,
  loading: (state) => state.loading
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/getters.js